import logEvent from '../logEvent';

function logEventOnboarding(code, data, isCoSub) {
  logEvent(`ONBD-${code}${isCoSub ? '-CO' : ''}`, data);
}

export function logEventSignupPage(data) {
  logEventOnboarding('01', data);
}

export function logEventSignupComplete() {
  logEventOnboarding('02');
}

export function logEventOnboardingStart() {
  logEventOnboarding('03');
}

export function logEventOnboardingSubscriberDetails(data, isCoSub) {
  logEventOnboarding('04', data, isCoSub);
}

export function logEventOnboardingIdvStart(isCoSub) {
  logEventOnboarding('05', undefined, isCoSub);
}

export function logEventOnboardingIdvSuccess(verificationJob, isCoSub) {
  const { id } = verificationJob || {};
  logEventOnboarding('06', { jobId: id }, isCoSub);
}

export function logEventOnboardingUpdateAccount(isCoSub) {
  logEventOnboarding('07', undefined, isCoSub);
}

export function logEventOnboardingCoSubPopup() {
  logEventOnboarding('08');
}

export function logEventOnboardingCoSubPopupComplete() {
  logEventOnboarding('09', undefined, true);
}

export function logEventOnboardingConfirmReqs(data) {
  logEventOnboarding('10', data);
}

export function logEventOnboardingProfileStart() {
  logEventOnboarding('11');
}

export function logEventOnboardingCoSubRelationship() {
  logEventOnboarding('12', undefined, true);
}

export function logEventOnboardingSubscriberSin(isCoSub) {
  logEventOnboarding('13', undefined, isCoSub);
}

export function logEventOnboardingEmploymentStatus(isCoSub) {
  logEventOnboarding('14', undefined, isCoSub);
}

export function logEventOnboardingCivilStatus(isCoSub) {
  logEventOnboarding('15', undefined, isCoSub);
}

export function logEventOnboardingGrossIncome(isCoSub) {
  logEventOnboarding('16', undefined, isCoSub);
}

export function logEventOnboardingAssetsLiabilities(isCoSub) {
  logEventOnboarding('17', undefined, isCoSub);
}

export function logEventOnboardingDependents(isCoSub) {
  logEventOnboarding('18', undefined, isCoSub);
}

export function logEventOnboardingInvestingExperience(isCoSub) {
  logEventOnboarding('19', undefined, isCoSub);
}

export function logEventOnboardingIps1() {
  logEventOnboarding('20');
}

export function logEventOnboardingIps2() {
  logEventOnboarding('21');
}

export function logEventOnboardingIps3() {
  logEventOnboarding('22');
}

export function logEventOnboardingIps4() {
  logEventOnboarding('23');
}

export function logEventOnboardingIps5() {
  logEventOnboarding('24');
}

export function logEventOnboardingIps6() {
  logEventOnboarding('25');
}

export function logEventOnboardingIps7() {
  logEventOnboarding('26');
}

export function logEventOnboardingIps8() {
  logEventOnboarding('27');
}

export function logEventOnboardingRiskProfile() {
  logEventOnboarding('28');
}

export function logEventOnboardingChildProfileStart(data) {
  logEventOnboarding('29', data);
}

export function logEventOnboardingChildDetails(data) {
  logEventOnboarding('30', data);
}

export function logEventOnboardingChildSin(data) {
  logEventOnboarding('31', data);
}

export function logEventOnboardingApplicationReview(isCoSub) {
  logEventOnboarding('32', undefined, isCoSub);
}

export function logEventOnboardingTermsConditions(isCoSub) {
  logEventOnboarding('33', undefined, isCoSub);
}

export function logEventOnboardingComplete(data, isCoSub) {
  logEventOnboarding('34', data, isCoSub);
}

export function logEventOnboardingIdvFail(verificationJob, isCoSub) {
  const { id, errors, result, request } = verificationJob || {};
  const { parameters } = request || {};
  logEventOnboarding(
    '35',
    {
      jobId: id,
      errors,
      entered: {
        firstName: parameters && parameters.firstName,
        lastName: parameters && parameters.lastName,
        birthDate: parameters && parameters.dob
      },
      identification: {
        type: result && result.type,
        country: result && result.country,
        expireDate: result && result.expireDate,
        firstName: result && result.firstName,
        middleName: result && result.middleName,
        lastName: result && result.lastName,
        birthDate: result && result.birthDate,
        confidences: result && result.confidences
      }
    },
    isCoSub
  );
}

export function logEventGoalPopupComplete() {
  logEventOnboarding('36');
}

export function logEventOnboardingPlanType(data) {
  logEventOnboarding('37', data);
}

export function logEventOnboardingCalculator(eventCode, data) {
  logEventOnboarding(eventCode, data);
}

export function logEventOnboardingMoneyQuestion() {
  logEventOnboarding('Money_Question');
}

export function logEventOnboardingMoneyQuestionPageLoad() {
  logEventOnboarding('Money_Question_PageLoad');
}

export function logEventOnboardingMoneyQuestionBack() {
  logEventOnboarding('Money_Question_Back');
}

export function logEventOnboardingBalancingBenefit(data) {
  logEventOnboarding('Balancing_Benefit', data);
}
